export const FETCH_MACHINE_READABLE_TEMPLATES =
  'mrt/FETCH_MACHINE_READABLE_TEMPLATES';

export const UPLOAD_MACHINE_READABLE_TEMPLATES =
  'mrt/UPLOAD_MACHINE_READABLE_TEMPLATES';

export const DOWNLOAD_MACHINE_READABLE_TEMPLATE =
  'mrt/DOWNLOAD_MACHINE_READABLE_TEMPLATE';

export const DOWNLOAD_MACHINE_READABLE_TEMPLATE_ERROR_FILE =
  'mrt/DOWNLOAD_MACHINE_READABLE_TEMPLATE_ERROR_FILE';
